module.exports = __webpack_public_path__ + "assets/img/effect_(2).704e7700.gif";